import { inject, type InjectionKey, type Ref } from 'vue'

interface UseElementScrollTopOptions {
  injectionKey?: InjectionKey<Ref<HTMLElement>>
  elementRef?: Ref<HTMLElement | null>
}

export const useElementScrollTop = (options: UseElementScrollTopOptions) => {
  const el = options.injectionKey ? inject(options.injectionKey) : options.elementRef

  const scrollElementToTop = () => {
    el?.value?.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return {
    scrollElementToTop
  }
}
